import { useEffect, useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useUserWebSocket } from '@cibo/profile'
import { CarbonLabUserWsMessage } from '@cibo/core'
import { QUERY_KEY, LAND_REPORT_QUERY_KEY } from '../../..'
import { path } from 'ramda'

/**
 *
 * @todo - observe/hook into pending jobs
 */
export const useActiveJobs = () => {
  const queryClient = useQueryClient()
  const [completedJob, setCompletedJob] = useState<CarbonLabUserWsMessage>()
  const { lastMessage } = useUserWebSocket('job')

  useEffect(() => {
    if (path(['details', 'jobCode'], lastMessage) === 'CcrAggregate') {
      const resourceIds = path<unknown[]>(['details', 'inputs', 'resourceIds'], lastMessage)
      /**
       * invalidate queries that may have used data related to this result
       */
      if (resourceIds) {
        queryClient.invalidateQueries([QUERY_KEY.COLLECTION])
        queryClient.invalidateQueries([LAND_REPORT_QUERY_KEY.LAND_REPORT])
      }
      queryClient.invalidateQueries([
        'carbonComparisonJob',
        path(['details', 'jobId'], lastMessage),
      ])
      queryClient.invalidateQueries([
        QUERY_KEY.CARBON_COMPARISON,
        path(['details', 'inputs'], lastMessage),
      ])
      setCompletedJob(lastMessage as CarbonLabUserWsMessage)
    }
  }, [lastMessage, queryClient])

  return { completedJob }
}
